export default __webpack_public_path__ + "static/PortfolioSIte-bcfe97e1d1ad029e9bed1f958e2909d4.png";